import React from "react";


import { motion } from "framer-motion";

const BrandCarousel = () => {
  // Brand images array for duplication (infinite scroll effect)
  const brands = [
    "assets/new-images/rhema.png",
    "assets/new-images/deeptech.png",
    "assets/new-images/nextgen.png",
    "assets/new-images/3mtt.png",
    "assets/new-images/tvet.png",
    "assets/new-images/airtel.png",
    "assets/new-images/nira.png",
    "assets/new-images/min-of-edu.png",
    "assets/new-images/nitda.png",
    "assets/img/brand/ibm_1.webp",
    "assets/new-images/nbte.png",
    "assets/new-images/internet-society.png",
    "assets/new-images/gogl.png",
    "assets/new-images/FMCID.png",
  ];

  return (
    <div className="revamp-brands">
        <style>
          {`
            @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}
        </style>
        <div className="container text-center" style={{ marginBottom: "40px" }}>
            <h2 className="revamp-section-title" style={{ fontSize: "2.2rem" }}>Our Partners</h2>
        </div>
        <div className="revamp-brands__overflow-wrapper" style={{ overflow: "hidden", display: "flex", userSelect: "none" }}>
            <div 
              className="revamp-brands__track"
              style={{ 
                display: "flex", 
                gap: "60px", 
                paddingRight: "60px",
                animation: "marquee 40s linear infinite",
                width: "fit-content"
              }}
            >
                {/* Render the set twice for seamless looping */}
                {[...brands, ...brands].map((url, i) => (
                    <img key={i} src={url} alt="partner brand" style={{ height: "45px", width: "auto", flexShrink: 0, objectFit: "contain", opacity: 0.8, filter: "grayscale(0%)" }} />
                ))}
            </div>
        </div>
    </div>
  );
};

export default BrandCarousel;